export default "__VITE_ASSET__BLTBgrka__"